export default __webpack_public_path__ + "static/media/8ab0370c2dd30bcb345ad4c3f555a05f.png";